import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheApi, AssistitiApi, EntiApi, OperatoriApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useDeambulazioneAusiliDataSource() {
    const api = new AnagraficheApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {       
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getDeambulazioneAusili({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getDeambulazioneAusilioById({
                tenantId: currentTenant.Id,
                deambulazioneAusilioId: key
            });
          },
    
          insert: (values) => {
            return api.insertDeambulazioneAusilio({
                tenantId: currentTenant.Id,
                deambulazioneAusilioCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateDeambulazioneAusilio({
                tenantId: currentTenant.Id,
                deambulazioneAusilioId: key,
                deambulazioneAusilioUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteDeambulazioneAusilio({
                tenantId: currentTenant.Id,
                deambulazioneAusilioId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


